module.exports = __webpack_public_path__ + "wp-content/themes/clarks/img/true-or-false-score-bg.jpg";